import React from "react";
import Context from "../../../../context";

import {
  CustomBadges,
  CustomIcon,
  CustomSubLogin,
  TableNullData,
  UserInformation,
} from "../../../../components";

import "./index.scss";
import Cookies from "js-cookie";
import values from "../../../../values";
import utils from "../../../../utils";
import constants from "../../../../values/constants";
import { useTranslation } from "react-i18next";

type Props = {
  data: any[];
};

const Body = ({ data }: Props) => {
  const { setShowModal, setSelectedUser } = React.useContext(
    Context.UserScreen
  );

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(values.constants.USER.TYPE)
  );

  function onUpdate(admin: any) {
    setSelectedUser(admin);
    setShowModal("UPDATE");
  }

  // ========================================== JSX Content =============================================
  const showInformation = (user: any) => {
    setSelectedUser(user);
    setShowModal("SHOW_INFORMATION");
  };

  const writePermission = Cookies.get(
    constants.USER.WRITE_PERMISSION
  )?.toString();

  const { t } = useTranslation();

  if (data?.length <= 0 || !data) return <TableNullData />;
  return (
    <tbody id="super-agent-table-body-content">
      {data?.map((admin: any, index: number) => {
        return (
          <tr key={`admin-${index}`}>
            {/* admin Information */}
            <td onClick={() => showInformation(admin)}>
              <UserInformation
                name={admin?.firstName}
                lastName={admin?.lastName}
              />
            </td>
            {/* actions */}
            <td>{admin?.phoneNumber}</td>
            <td>
              {admin?.isPrimary && (
                <CustomBadges
                  title={admin?.isPrimary ? t("primaryAdmin") : ""}
                  type="primary"
                />
              )}
            </td>

            <td>
              {writePermission === "true" && (
                <div className="table-actions-buttons">
                  {/* Edit Icon */}
                  <CustomIcon
                    icon="fas fa-pen"
                    hoverTitle={t("update")}
                    onClick={() => onUpdate(admin)}
                  />
                  {/* {userType === "ADMIN" && (
                    <CustomSubLogin userId={admin._id} />
                  )} */}
                  {/* Delete Modal */}
                  {/* <CustomIcon icon="fas fa-trash" hoverTitle="حذف" onClick={() => onDelete(admin)} /> */}
                  {/* Block Icon */}
                  {/* <CustomIcon icon="fas fa-ban" hoverTitle="مسدود کردن" onClick={() => console.log("Block")} /> */}
                  {/* Block-Reason Icon */}
                  {/* {admin?.blocks.length > 0 && (
                  <CustomIcon icon="fas fa-shield-xmark" hoverTitle="دلیل مسدودی" onClick={() => console.log("Reason")} />
                )} */}
                </div>
              )}
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default Body;
